export class MultipleValidator {
    get formValidator() {
        return (value: string) => {
            const errors = [];
            const val = this.valueProcessor ? this.valueProcessor(value) : value;

            for (const key of Object.keys(this.validators)) {
                const validator = this.validators[key];

                if (validator(val)) {
                    errors.push(key);
                }
            }

            if (errors.length) {
                return '|' + errors.join('|');
            }
        };
    }

    constructor(private validators: Record<string, (val: string) => boolean>) {}

    valueProcessor?: (val: string) => string = val => val?.trim() ?? '';

    errorMap(error?: string): Record<string, boolean> | undefined {
        const out: Record<string, boolean> = {};

        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (!error || !error.startsWith('|')) {
            return;
        }

        const errors = error.split('|').slice(1);

        if (!errors.length) {
            return;
        }

        for (const key of Object.keys(this.validators)) {
            out[key] = errors.includes(key);
        }

        return out;
    }
}
